import React from "react";
import { useQuery } from "react-query-legacy";
import { BillingEngineService } from "services";
import { Service } from "services/BillingEngineService/interfaces";

interface Props {
  services: Service[];
  currentService?: Service;
  status: string;
}

const ServiceContext = React.createContext<Props | undefined>(undefined);

const ServicesContextProvider: React.FC = ({ children }) => {
  const status = "";
  const services: never[] = [];

  return (
    <ServiceContext.Provider
      value={{
        services: services,
        status,
      }}
    >
      {children}
    </ServiceContext.Provider>
  );
};

/**
 * Hook to get access to OrganizationRateCardProvider
 */
const useServicesContext = () => {
  const context = React.useContext(ServiceContext);

  if (!context) {
    throw new Error("useServicesContext can be used only inside <ServicesContextProvider />");
  }

  return context;
};

export { useServicesContext };
